import React, { Component } from 'react'
import { Col, Input, Dropdown, Menu, Icon, Tooltip } from 'antd'
import { app } from "../app"
import api from "../api"
const SubMenu = Menu.SubMenu

class Search extends Component {
    constructor (props) {
        super(props)
        this.state = {
            classList: [],
            search_val_flag: false,
            search_type_str: '编号',
            search_type: 'searchform_code',
        }
    }

    async componentDidMount () {
        this._isMounted = true
        let { flag, data, msg } = await app.post(api.HomeClassList)
        this.setData({ class_loading: false })
        if (flag === 1) {
            this.setData({ classList: data })
        } else {
            app.alert(msg, "error")
        }
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 搜索跳转
     * @returns {boolean}
     */
    handleSearch = (value) => {
        const search_val = value, search_val_flag = this.state.search_val_flag
        if (!search_val) {
            if (search_val_flag === false) {
                this.setData({ search_val_flag: true })
                const timer = setTimeout(() => {
                    this.setData({ search_val_flag: false })
                    clearTimeout(timer)
                }, 3000)
            }
            return false
        }
        this.props.history.push(`/search-result/${this.state.search_type}/${search_val}`);
    }

    handleMenuClick = (e) => {
        const search_type_str = e.item.props.children, search_type = e.key
        this.setData({ search_type, search_type_str })
    }
   
    render () {
        let {class_loading, search_type_str, search_val_flag, classList} = this.state
        return (
            <div className="s_zj">
                <Input.Group className="search" compact>
                    <Col span={5} style={{ height: "100%" }}>
                        <Dropdown overlay={
                            <Menu
                                onClick={this.handleMenuClick}
                            >
                                <Menu.Item key="searchform_code">编号</Menu.Item>
                                <Menu.Divider/>
                                <Menu.Item key="searchform_name">姓名</Menu.Item>
                                <Menu.Divider/>
                                {/*<Menu.Item key="searchform_area">行政省</Menu.Item>*/}
                                {/*<Menu.Divider/>*/}
                                {/*<Menu.Item key="4" disabled>服务时长</Menu.Item>*/}
                                {/*<Menu.Divider/>*/}
                                <Menu.Item key="searchform_mobile">手机号码</Menu.Item>
                                <Menu.Divider/>
                                <Menu.Item key="searchform_team">队伍</Menu.Item>
                                {/*<SubMenu key="sub2"*/}
                                {/*         title={(*/}
                                {/*             <span>救援技能{class_loading ? <Icon type="loading"/> : ''}</span>)}>*/}
                                {/*    {*/}
                                {/*        classList.map((cla) => {*/}
                                {/*            return (<Menu.Item key={cla.id}>{cla.names}</Menu.Item>)*/}
                                {/*        })*/}
                                {/*    }*/}
                                {/*</SubMenu>*/}
                            </Menu>} trigger={['click']}>
                            <div className="z_s">
                                <span>{search_type_str}</span>
                                <Icon type="down"/>
                            </div>
                        </Dropdown>
                    </Col>
                    <Col span={19} style={{ height: "100%" }}>
                        <Tooltip placement="bottomLeft" title="请输入搜索内容" trigger="" visible={search_val_flag}>
                            <Input.Search
                                placeholder="请输入搜索内容"
                                onSearch={this.handleSearch}
                                style={{ height: "100%" }}
                                size="large"
                                enterButton
                            />
                        </Tooltip>
                    </Col>
                </Input.Group>
            </div>
        )
    }
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search.jsx